import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      class: "cameras-svg-fill"
    }, [
      _createElementVNode("path", { d: "M22.625 4.9h-15c-.752 0-1.363.636-1.363 1.42v11.364c0 .783.611 1.42 1.363 1.42h15c.752 0 1.364-.637 1.364-1.42V6.32c0-.784-.612-1.42-1.364-1.42m-.272 12.5H7.898V6.603h14.455z" }),
      _createElementVNode("path", { d: "M6.711 13.968 1.625 16.64V7.342L6.72 9.927l.717-1.533-6.273-3.182a.79.79 0 0 0-.792.044.86.86 0 0 0-.384.723v12.045c0 .296.147.57.389.725a.8.8 0 0 0 .797.036l6.273-3.296z" })
    ], -1)
  ])))
}
export default { render: render }